export default __webpack_public_path__ + "static/media/Facebook.e760d717.svg";